/*
 * <recommended-products> — D-20, the legacy product-recommendations section.
 *
 * Live shipped this as an inline section script defining a second
 * <product-recommendations> element; the rebuild's global.js already owns
 * that tag name (Dawn's related-products contract, incompatible data-url
 * shape), and both sections can share a PDP — so this element carries its
 * own name. Behaviour is live's:
 *   - fetch the section render once the element nears the viewport;
 *   - drop products from the excluded collections (the server over-fetches
 *     by the exclusion count so the trim still fills the grid);
 *   - trim to the configured product limit;
 *   - swap in the fetched grid.
 * Live then re-ran the REVIEWS.io rating-snippet embed's global function so
 * stars painted on the injected cards. The rebuild's cards render their stars
 * server-side, drawn by component-star-rating.css, and carry
 * data-retrieved="true", so that call had nothing left to do (D-30).
 */
if (!customElements.get('recommended-products')) {
  customElements.define(
    'recommended-products',
    class RecommendedProducts extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const parser = new DOMParser();
              const section = this.closest('.shopify-section') || document;
              const settingsEl =
                section.querySelector('[data-exclude-collections]') ||
                document.querySelector('[data-exclude-collections]');
              const excludeSettings = settingsEl
                ? JSON.parse(settingsEl.innerText)
                : { product_limit: 0, excluded_products: [] };
              const html = document.createElement('div');
              const parsedHTML = parser.parseFromString(text, 'text/html');
              const recommendations = parsedHTML.querySelector('recommended-products');
              if (!recommendations) return;

              excludeSettings.excluded_products.forEach((productId) =>
                recommendations
                  .querySelectorAll(`li[data-item-id="${productId}"]`)
                  .forEach((gridItem) => gridItem.remove())
              );

              const recommendationItems = recommendations.querySelectorAll(`li`);
              const recommendationCount = recommendationItems.length;
              if (excludeSettings.product_limit > 0 && recommendationCount > excludeSettings.product_limit) {
                for (var i = excludeSettings.product_limit; i < recommendationCount; i++) {
                  recommendationItems[i].remove();
                }
              }

              html.innerHTML = recommendations.innerHTML;

              if (recommendationCount > 0) {
                this.innerHTML = recommendations.innerHTML;
              }

              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }
    }
  );
}
